var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EventTypes, RouteTypes, BrowserBreadcrumbTypes } from '@heimdallr-sdk/types';
import { formatDate, generateUUID, replaceOld } from '@heimdallr-sdk/utils';
import { supportsHistory } from './utils';
var historyPlugin = {
    name: 'historyPlugin',
    monitor: function (notify) {
        var lastHref = '';
        if (!supportsHistory())
            return;
        var originOnpopstate = window.onpopstate;
        window.onpopstate = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var to = document.location.href;
            var from = lastHref;
            lastHref = to;
            notify({
                from: from,
                to: to
            });
            originOnpopstate && originOnpopstate.apply(this, args);
        };
        function historyReplaceFn(originalHistoryFn) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var url = args.length > 2 ? args[2] : undefined;
                if (url) {
                    var from = lastHref;
                    var to = String(url);
                    lastHref = to;
                    notify({
                        from: from,
                        to: to
                    });
                }
                return originalHistoryFn.apply(this, args);
            };
        }
        replaceOld(window.history, 'pushState', historyReplaceFn);
        replaceOld(window.history, 'replaceState', historyReplaceFn);
    },
    transform: function (collectedData) {
        var id = generateUUID();
        var from = collectedData.from, to = collectedData.to;
        if (from === to) {
            return;
        }
        this.breadcrumb.unshift({
            eventId: id,
            type: BrowserBreadcrumbTypes.ROUTE,
            message: "from \"".concat(from, "\" to \"").concat(to, "\" by history")
        });
        return {
            id: id,
            time: formatDate(),
            type: EventTypes.ROUTE,
            data: __assign({ sub_type: RouteTypes.HISTORY }, collectedData)
        };
    }
};
export default historyPlugin;
